import { login, logout } from '@/api/login'
import { userInfo} from '@/api/common'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, data) => {
      state.info = data
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const googleCode = userInfo.googleCode ? userInfo.googleCode.trim() : ''
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, googleCode).then(response => {
          setToken(true)
          commit('SET_TOKEN', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        userInfo().then(response => {
          const data = response.data
          if(data.type == 1) {
            commit('SET_INFO', data)
            commit('SET_NAME', data.username)
            commit('SET_AVATAR', data.img)
            resolve(response)

          } else {
            // 非admin账号不给登录
            this.$router.push({path: '/login'})
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
          console.log(22)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js